module.exports = __webpack_public_path__ + "img/zdycd.ac60dc76.svg";